/* eslint-disable */
import React, { Component } from "react";
import WebinarRESTService from "../../services/WebinarRESTService";
import WebinarsListItem from "../../components/Webinars/WebinarsListItem";
import PaginationHelper from "../SOA/FinancialMathematics/Readings/pagination";
import Loader from "../../common/loader";
import '../../assets/css/webinars.css';
import userStore from "../../store/userStore";
import { getSocket } from "../../services/WebSocketService";

const REGION_LABELS = {
    'NA': 'North America',
    'EU': 'Europe',
    'APAC': 'Asia Pacific',
    'LATAM': 'Latin America',
    'MEA': 'Middle East & Africa',
    'UK': 'United Kingdom',
};

function getRegionLabel(region) {
    return REGION_LABELS[region] || region;
}

class WebinarsList extends Component {

    static contextTypes = { router: React.PropTypes.object };

    constructor(props, context) {
        super(props, context);
        this.state = {
            items: [],
            userData: {
                profile: null,
                token: null,
            },
            currentPage: 1,
            perPage: 9,
            totalCount: 0,
            filters: {
                tags: [],
                regions: [],
            },
            selectedTags: [],
            selectedRegion: null,
            sessionType: 'upcoming',
            upcomingCount: 0,
            pastCount: 0,
            isLoading: true,
        }
    }

    async componentDidMount() {
        const profile = await userStore.fetchProfile();
        const token = userStore.token;
        this.setState({ userData: { profile, token } });
        const page = parseInt(this.props.location && this.props.location.query && this.props.location.query.page, 10) || 1;
        await this.listWebinars(page);
        await this.listFilters();
        const socket = getSocket();
        socket.on('webinar_data_update', (data) => {
            if (data) {
                const webinarId = data.id;
                this.setState(prevState => ({
                    items: prevState.items.map(item =>
                        item.id === webinarId ? data : item
                    )
                }));
            }
        });
    }

    listWebinars = async (page = 1) => {
        this.setState({ isLoading: true });
        try {
            const dto = {
                page: page,
                perPage: this.state.perPage,
                tags: this.state.selectedTags,
                type: this.state.sessionType,
                region: this.state.selectedRegion,
            };
            const data = await new WebinarRESTService()
                .setAuthHeader(this.state.userData.token)
                .getWebinarsList(dto);
            if (data != null) {
                this.setState({
                    items: data.items || [],
                    totalCount: data.count || 0,
                    currentPage: page,
                });
            }
        } catch (e) {
            console.log("ListWebinarsERROR:: ", e);
        } finally {
            setTimeout(() =>
                this.setState({ isLoading: false })
                , 500)
        }
    }

    listFilters = async (filters) => {
        try {
            const data = await new WebinarRESTService()
                .setAuthHeader(this.state.userData.token)
                .getFIlters();
            if (data != null) {
                this.setState({
                    filters: data,
                    upcomingCount: data.upcomingCount || 0,
                    pastCount: data.pastCount || 0,
                });
            }
        } catch (e) {
            console.log("Error in listFilters:: ", e);
        }
    }

    updateWebinarItem = async (webinarId) => {
        try {
            const data = await new WebinarRESTService()
                .setAuthHeader(this.state.userData.token)
                .getWebinarItem(webinarId);
            if (data != null) {
                this.setState(prevState => ({
                    items: prevState.items.map(item =>
                        item.id === webinarId ? data : item
                    )
                }));
            }
        } catch (e) {
            console.log("updateWebinarItem::error", e);
        }
    }

    handleTagClick = (tag) => {
        this.setState(prevState => {
            const selected = prevState.selectedTags.includes(tag)
                ? prevState.selectedTags.filter(t => t !== tag)
                : [...prevState.selectedTags, tag];
            return { selectedTags: selected };
        }, () => this.listWebinars(1));
    }

    handleSessionTypeChange = (type) => {
        if (type === this.state.sessionType) return;
        this.setState({ sessionType: type, selectedTags: [], selectedRegion: null }, () => this.listWebinars(1));
    }

    handleAllClick = () => {
        this.setState({ selectedTags: [] }, () => this.listWebinars(1));
    }

    handleRegionClick = (region) => {
        const newRegion = this.state.selectedRegion === region ? null : region;
        this.setState({ selectedRegion: newRegion }, () => this.listWebinars(1));
    }

    handleRegionAllClick = () => {
        this.setState({ selectedRegion: null }, () => this.listWebinars(1));
    }

    onPageChanged = (paginationData) => {
        const { currentPage } = paginationData;
        if (currentPage === this.state.currentPage) return;
        this.context.router.push({ pathname: '/webinars', query: { page: currentPage } });
        this.listWebinars(currentPage);
    }

    render() {

        const {
            items,
            totalCount,
            currentPage,
            perPage,
            filters,
            selectedTags,
            selectedRegion,
            sessionType,
            upcomingCount,
            pastCount,
            isLoading
        } = this.state;
        const tags = filters && filters.tags ? filters.tags : [];
        const regions = filters && filters.regions ? filters.regions : [];

        if (isLoading) {
            return (
                <div className="animated fadeIn">
                    <Loader />
                </div>
            );
        }
        return (
            <div className="webinars-wrapper">
                <div className="webinars-container">
                    {/* {filters && (filters.pastCount > 0 && filters.upcomingCount > 0) ? (
                        <div className="webinar-session-tabs">
                            <button
                                className={'webinar-session-tab' + (sessionType === 'upcoming' ? ' webinar-session-tab--active' : '')}
                                onClick={() => this.handleSessionTypeChange('upcoming')}
                                type="button"
                            >
                                <svg className="webinar-session-tab__icon" width="16" height="16" viewBox="0 0 16 16"
                                     fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12.667 2.667H3.333C2.597 2.667 2 3.264 2 4v9.333c0 .737.597 1.334 1.333 1.334h9.334c.736 0 1.333-.597 1.333-1.334V4c0-.736-.597-1.333-1.333-1.333zM10.667 1.333v2.667M5.333 1.333v2.667M2 6.667h12"
                                        stroke="currentColor" strokeWidth="1.33" strokeLinecap="round"
                                        strokeLinejoin="round"/>
                                </svg>
                                Upcoming
                                {upcomingCount > 0 && <span className="webinar-session-tab__count">{upcomingCount}</span>}
                            </button>
                            <button
                                className={'webinar-session-tab' + (sessionType === 'past' ? ' webinar-session-tab--active' : '')}
                                onClick={() => this.handleSessionTypeChange('past')}
                                type="button"
                            >
                                <svg className="webinar-session-tab__icon" width="16" height="16" viewBox="0 0 16 16"
                                     fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334z"
                                          stroke="currentColor" strokeWidth="1.33" strokeLinecap="round"
                                          strokeLinejoin="round"/>
                                    <path d="M8 4v4l2.667 1.333" stroke="currentColor" strokeWidth="1.33"
                                          strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Past Sessions
                                {pastCount > 0 && <span className="webinar-session-tab__count">{pastCount}</span>}
                            </button>
                        </div>
                    ) : null} */}

                    {tags.length > 0 && (
                        <div className="webinar-filters">
                            <span className="webinar-filters__label">Filter:</span>
                            <button
                                className={'webinar-filter-tag' + (selectedTags.length === 0 ? ' webinar-filter-tag--active' : '')}
                                onClick={this.handleAllClick}
                                type="button"
                            >
                                All
                            </button>
                            {tags.map((tag, idx) => (
                                <button
                                    className={'webinar-filter-tag' + (selectedTags.includes(tag) ? ' webinar-filter-tag--active' : '')}
                                    onClick={() => this.handleTagClick(tag)}
                                    type="button"
                                    key={'ftag_' + idx}
                                >
                                    {tag}
                                </button>
                            ))}
                        </div>
                    )}

                    {regions.length > 0 && (
                        <div className="webinar-filters">
                            <span className="webinar-filters__label">Location:</span>
                            <button
                                className={'webinar-filter-tag' + (selectedRegion == null ? ' webinar-filter-tag--active' : '')}
                                onClick={this.handleRegionAllClick}
                                type="button"
                            >
                                All
                            </button>
                            {regions.map((region, idx) => (
                                <button
                                    className={'webinar-filter-tag' + (selectedRegion === region ? ' webinar-filter-tag--active' : '')}
                                    onClick={() => this.handleRegionClick(region)}
                                    type="button"
                                    key={'fregion_' + idx}
                                >
                                    {getRegionLabel(region)}
                                </button>
                            ))}
                        </div>
                    )}

                    <div className="webinar-list-container">
                        {/*
                         * Client-side safety-net sort: live sessions always render first.
                         * The backend SQL ORDER BY uses naive datetime comparisons which
                         * can misclassify cross-region webinars; `sessionState` on each
                         * item is timezone-aware, so this sort is authoritative.
                         */}
                        {items
                            .slice()
                            .sort((a, b) => {
                                const aLive = a && a.sessionState === 'live' ? 0 : 1;
                                const bLive = b && b.sessionState === 'live' ? 0 : 1;
                                return aLive - bLive;
                            })
                            .map((item, idx) => (
                                <WebinarsListItem
                                    item={item}
                                    userData={this.state.userData}
                                    onWebinarUpdate={this.updateWebinarItem}
                                    key={`wbi_${idx}`}
                                />
                            ))}
                    </div>

                    {totalCount > perPage && (
                        <div className="webinar-pagination">
                            <PaginationHelper
                                totalRecords={totalCount}
                                currentPage={currentPage}
                                pageLimit={perPage}
                                pageNeighbours={1}
                                onPageChanged={this.onPageChanged}
                            />
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default WebinarsList;



// WEBPACK FOOTER //
// ./src/views/Webinars/WebinarsList.js